export const azureMapsKey =
  process.env.NODE_ENV === 'production'
    ? '7dXk3CgPiglbdVzq19FOpPT9TtwCSSpanrlZCLQUWNKvMY2yf0zsJQQJ99AIACi5YpzTR9r6AAAgAZMP4R7b'
    : '65QD9Znu1GdCjUfqConYr55fpmKYlVIAITtdjNkpRU3FAJM0iVhsJQQJ99AHACi5YpzTR9r6AAAgAZMPxg1K';
